<template>
  <div class="psPatientPhysicalActivityDetail">
    <div class="row">
      <div class="column w-100">
        <div class="label">Actividad física</div>
        <el-input 
          type="textarea"
          :rows="5"
          :maxlength="1000"
          show-word-limit
          :value="itemPhysicalActivity.description" 
          @input="PATIENTS_ITEM_PHYSICAL_ACTIVITY_PROP({property: 'description', value: $event})"
        ></el-input>
      </div>
      <div class="column" v-if="itemPhysicalActivity.id > 0">
        <div class="label">&nbsp;</div>
        <el-button type="danger" icon="el-icon-delete" plain @click="deletePhysicalActivity"></el-button>
      </div>
    </div>
    <el-button @click="savePhysicalActivity" icon="el-icon-check" type="success" round class="btnSave" :disabled="itemPhysicalActivity.description == ''">{{ itemPhysicalActivity.id > 0 ? 'Actualizar' : 'Guardar' }}</el-button>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'PsPatientPhisicalActivityDetail',
  computed: {
    ...mapState('patients', ['itemPhysicalActivity'])
  },
  methods: {
    ...mapMutations('patients', ['PATIENTS_ITEM_PHYSICAL_ACTIVITY_PROP', 'PATIENTS_DIALOG_PHYSICAL_ACTIVITY']),
    ...mapActions('patients', ['savePhysicalActivityPatient', 'getPatientHTTP', 'deletePhysicalActivityPatientHTTP']),
    async savePhysicalActivity () {
      let loading
      try {
        loading = this.$loading({
          lock: true,
          text: 'Guardando...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });   

        const message = await this.savePhysicalActivityPatient()
        this.$message( { message, type: 'success' } )
        setTimeout( async () => {
          await this.getPatientHTTP( this.$route.params['patientId'])
          loading.close()
          this.PATIENTS_DIALOG_PHYSICAL_ACTIVITY(false)
        }, 1000)
      } catch ( err ) { this.$message( { message: err.response.data.err.details, type: 'error' })}
      finally { loading.close()}
     
    },
    async deletePhysicalActivity () {
      let loading
      try {
        this.$confirm('¿Quiere eliminar esta actividad física?', 'Confirmación', {
          type: 'warning',
          confirmButtonText: 'Si',
          cancelButtonText: 'No'
        })
        .then( async () => {
          loading = this.$loading({
            lock: true,
            text: 'Eliminando...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          }); 
          const message = await this.deletePhysicalActivityPatientHTTP()
          setTimeout( async () => {
            await this.getPatientHTTP( this.$route.params['patientId'])
            this.PATIENTS_DIALOG_PHYSICAL_ACTIVITY(false)
            loading.close()
            this.$message.success(message)
          }, 1000)
        })
        .catch( () => {})
      } catch ( err ) { this.$message.error('No se pudo eliminar esta actividad física.')}
    }
  }
}
</script>

<style>

</style>